import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type ProjectsSearchParams, projectsApiSchema } from '../models';
import { logger } from '../utils/logger';
import * as mock from './mock';

const procurement = fetcher.extend(() => ({ prefixUrl: `${API.PROCUREMENT}` }));

export const fetchProjects = async (
  searchParams: ProjectsSearchParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await procurement
      .get('GetProjectListBySearch', { searchParams: toURLSearchParams(searchParams), signal })
      .json(projectsApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Projects error: ${error.response.status}`);
    }
    throw error;
  }
};

export const fetchSortingOptions = (options: { signal?: AbortController['signal'] } = {}) =>
  mock.fetchSortingOptions(options);
